// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// import scripts
import 'jquery-parallax-scroll/js/jquery.parallax-scroll';
// require main js file
require('@js/index');
require('@js/header');
require('@js/resources-popup');
require('@js/video-bg');
require('@js/select');
require('@js/swiper');
require('@js/accordion');
require('@js/tab');
require('@js/ajax-blog');
require('@js/smooth-anchor-links');
require('@js/map');
